import { render } from "./EmailField.vue?vue&type=template&id=ca4b19b8"
import script from "./EmailField.vue?vue&type=script&lang=js"
export * from "./EmailField.vue?vue&type=script&lang=js"

import "./EmailField.vue?vue&type=style&index=0&id=ca4b19b8&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__